<img class="interactive" (click)="switchOn()" src="../../../../assets/left-arrow.svg" alt="Return">
<span class="text">
  <ng-content></ng-content>
</span>
